import React from 'react';
import { Modal, Select } from 'antd';

export interface SelectMoveProps {
  visible?: boolean,
  onOk?: () => void,
  onCancel?: () => void,
  title?: string,
  onChange?: (value: number) => void,
  dataSource: any[]
  placeholder?: string
}

const ModalSelect: React.FC<SelectMoveProps> = props => {
  
  const {visible, onOk, onCancel, title, dataSource, placeholder, onChange} = props;
  
  const Option = Select.Option;
  
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Select
        showSearch
        style={{ width: 200 }}
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={onChange}
        filterOption={(input, option: any) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {dataSource.map((r:any) => <Option key={r.id} value={r.id}>{r.name}</Option>)}
      </Select>
    </Modal>
  )
  
}

ModalSelect.defaultProps = {
  visible: true,
  onOk: () => {},
  onCancel:  () => {},
  title: '弹窗',
  dataSource: [],
  placeholder: '请选择'
}

export default ModalSelect;
